import { baseRoute } from '../../constants/routes';

export const ROLES_ROUTE = baseRoute + '/roles';

export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
